import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";

import {
  ACCESS_LEVELS,
  AUTH_ROLES,
  PERMISSION_AREAS,
} from "api/common/types/auth.types";
import { Ecr } from "api/memberPortal/ecr/ecr.types";
import ActionsCell from "components/MUI/DataGrid/Cells/Actions/Actions.cell";
import IconMenuItem from "components/MUI/DataGrid/Cells/Actions/IconMenuItem";
import { useAuth } from "hooks/useAuth";
import { checkPermissions } from "utils/permissions";

interface EcrActionsCellProps {
  ecr: Ecr;
  setEcr?: (_ecr: Ecr) => void;
  setEcrToDelete?: (_ecr: Ecr) => void;
  setIsEditing?: (_isEditing: boolean) => void;
  setShowCommentForm: (_showCommentForm: boolean) => void;
  setShowDeleteModal?: (_showDeleteModal: boolean) => void;
}

const EcrActionsCell = ({
  ecr,
  setEcr,
  setIsEditing,
  setShowCommentForm,
  setShowDeleteModal,
  setEcrToDelete,
}: EcrActionsCellProps) => {
  const { currentUser, permissions } = useAuth();
  const navigate = useNavigate();

  const isEcrCreator = currentUser.id === ecr.creator?.id;
  const isValidator = permissions.role_type === AUTH_ROLES.VALIDATOR;
  const isNiap = permissions.role_type === AUTH_ROLES.NIAP;

  const canUpdate = checkPermissions({
    permissions,
    area: PERMISSION_AREAS.ECR_COMMENTS,
    access: ACCESS_LEVELS.UPDATE,
  });

  const canDelete = checkPermissions({
    permissions,
    area: PERMISSION_AREAS.ECR_COMMENTS,
    access: ACCESS_LEVELS.DESTROY,
  });

  const hasAllowedRole = isEcrCreator || isValidator || isNiap;

  const canAccessEdit = hasAllowedRole && canUpdate;
  const canAccessDelete = hasAllowedRole && canDelete;

  const handleView = () => {
    navigate(`/community/ecr-comments/details/${ecr.ecrid}`);
  };

  const handleEdit = () => {
    setEcr && setEcr(ecr);
    setIsEditing && setIsEditing(true);
    setShowCommentForm(true);
  };

  const handleDelete = () => {
    setShowDeleteModal && setShowDeleteModal(true);
    setEcrToDelete && setEcrToDelete(ecr);
  };

  return (
    <ActionsCell id={`ecrid-${ecr.ecrid}`}>
      <IconMenuItem
        Icon={VisibilityIcon}
        label="View"
        onClick={handleView}
        enabled={true}
      />

      <IconMenuItem
        Icon={EditIcon}
        label="Edit"
        onClick={handleEdit}
        enabled={canAccessEdit}
      />

      <IconMenuItem
        Icon={DeleteIcon}
        label="Delete"
        onClick={handleDelete}
        enabled={canAccessDelete}
      />
    </ActionsCell>
  );
};
export default EcrActionsCell;
